import { useQuery } from '@tanstack/react-query';
import { requestMaximumPaymentAmount } from './oneTimePaymentApi';

export const maximumPaymentAmountKey = ['payments', 'maximumPaymentAmount'] as const;

/**
 * The org-wide cap on a single one-time payment, used for the amount field's max and helper text.
 *
 * Callers should treat a failure here as non-blocking: the form stays usable and the mutation
 * rejects an over-cap amount with `AMOUNT_EXCEEDS_MAXIMUM`, so a Salesforce metadata outage
 * degrades the hint rather than the whole flow.
 */
export function useMaximumPaymentAmount() {
  return useQuery({ queryKey: maximumPaymentAmountKey, queryFn: requestMaximumPaymentAmount });
}
